// Pure helpers for the Marketplace installation table (no React, no API).
// Classification, counts, search and paging are computed server-side (GET /marketplace/installations/search).
// The cloud never pushes to an edge: the edge polls and reports back, so a queued row on an OFFLINE edge
// means "applied when it reconnects", not "updating".

import i18n from "../../i18n";

export const KIND_ORDER = ["failed", "updating", "waiting_offline", "outdated", "current"];

// Etiket seçili dile göre çözülür (modül yüklenirken değil, her çağrıda).
export const kindLabel = (kind) => i18n.t(`marketplace.kind.${kind}`, { defaultValue: kind });

export const KIND_COLOR = {
  failed: "var(--danger)",
  updating: "#f0883e",
  waiting_offline: "var(--text-muted)",
  outdated: "#d29922",
  current: "var(--success)",
  other: "#8957e5",
};

// "ghcr.io/x/valonix-oee@sha256:34c93540d7..." -> "34c93540"; "repo:1.2" -> "1.2"
export function shortImage(img) {
  if (!img) return "—";
  const d = img.match(/@sha256:([0-9a-f]{8})/);
  if (d) return d[1];
  return img.split(":").pop() || img;
}

// "26–50 / 120" ; "0 / 0" when empty
export function pageRange(page, pageSize, total) {
  if (!total) return "0 / 0";
  return `${(page - 1) * pageSize + 1}–${Math.min(page * pageSize, total)} / ${total}`;
}

export const lastPage = (pageSize, total) => Math.max(1, Math.ceil(total / pageSize));
